
define(['jquery', 'underscore', 'core'], function($, _, core) {
  var formatLedgerName, getCreditLedgers, getDebitLedgers, makeLedgerLine, nameMaxLength;
  nameMaxLength = 26;
  formatLedgerName = function(name) {
    if (name.length > nameMaxLength) {
      return [name.substr(0, nameMaxLength - 2) + '...', true];
    } else {
      return [name, false];
    }
  };
  makeLedgerLine = function(financialDocument) {
    return function(result, dataEntry, index, list) {
      var clazz, item, ledgerName, name, shortened, _ref, _ref1;
      item = '';
      ledgerName = ((_ref = core.getLedgersById()[dataEntry.ledgerAccountId]) != null ? _ref.name : void 0) || '';
      _ref1 = formatLedgerName(ledgerName), name = _ref1[0], shortened = _ref1[1];
      clazz = shortened ? 'shortened' : '';
      if (index < 1) {
        item = "<span data-ledger-id='" + dataEntry.ledgerAccountId + "' data-transaction-id='" + dataEntry.id + "' class='ledger-item " + clazz + "'>" + name + "</span>" + (index + 1 < list.length ? ', ' : '<br class=\'separator hide\'/>');
      } else if (index === 1) {
        item = " <span class='ledger-dots'>...</span><br class='separator hide'/>";
      }
      return result + item;
    };
  };
  getCreditLedgers = function(financialDocument) {
    var creditLedgers;
    creditLedgers = _.filter(financialDocument.dataEntries, function(dataEntry) {
      return dataEntry.entryType === 'CREDIT';
    });
    if (!creditLedgers) {
      return '';
    }
    return _.reduce(creditLedgers, makeLedgerLine(financialDocument), ' ');
  };
  getDebitLedgers = function(financialDocument) {
    var debitLedgers;
    debitLedgers = _.filter(financialDocument.dataEntries, function(dataEntry) {
      return dataEntry.entryType === 'DEBIT';
    });
    if (!debitLedgers) {
      return '';
    }
    return _.reduce(debitLedgers, makeLedgerLine(financialDocument), ' <span class="badge-arrow">&#x25b6;</span> ');
  };
  return {
    renderLedgers: function(financialDocument, simpleMode) {
      if (simpleMode == null) {
        simpleMode = false;
      }
      if (simpleMode) {
        return _.reduce(financialDocument.dataEntries, makeLedgerLine(financialDocument), '');
      } else {
        return getCreditLedgers(financialDocument) + getDebitLedgers(financialDocument);
      }
    },
    getControl: function(ledgerId, transactionId, parent) {
      var selector;
      selector = "[data-ledger-id='" + ledgerId + "'][data-transaction-id='" + transactionId + "']";
      if (parent) {
        return $(selector, parent);
      } else {
        return $(selector);
      }
    },
    getData: function(element) {
      return {
        'ledger-id': parseInt($(element).attr('data-ledger-id')),
        'transaction-id': parseInt($(element).attr('data-transaction-id'))
      };
    },
    update: function(data, element) {
      var key, val, _results;
      _results = [];
      for (key in data) {
        val = data[key];
        _results.push($(element).attr("data-" + key, val));
      }
      return _results;
    },
    nameMaxLength: nameMaxLength,
    formatLedgerName: formatLedgerName
  };
});
